import { Link } from "react-router-dom";

export function Logo({ className = "", onDark = true }) {
    return (
        <Link to="/" className={`inline-flex items-center gap-2.5 ${className}`} data-testid="logo">
            <img src="/sudigi-logo.jpeg" alt="SuDigi" className="h-10 w-10 rounded-full object-cover ring-1 ring-gold/50" />
            <span className="font-serif tracking-tight text-2xl font-bold leading-none">
                <span className="gold-text">Su</span><span className={onDark ? "text-cream" : "text-teal-900"}>Digi</span>
            </span>
        </Link>
    );
}

export function Eyebrow({ children }) {
    return <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] uppercase text-gold">{children}</div>;
}

export function SectionHeading({ eyebrow, title, subtitle, light = false, center = false }) {
    return (
        <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${center ? "" : ""}`}>
            {eyebrow && <div className="mb-3"><Eyebrow>{eyebrow}</Eyebrow></div>}
            <h2 className={`font-serif text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.08] ${light ? "text-teal-900" : "text-cream"}`}>{title}</h2>
            {subtitle && <p className={`mt-4 text-base ${light ? "text-teal-900/70" : "text-cream-soft"}`}>{subtitle}</p>}
        </div>
    );
}

export function GoldButton({ as = "button", className = "", children, ...props }) {
    const Comp = as;
    return <Comp className={`btn-gold rounded-full px-6 py-3 text-sm inline-flex items-center justify-center gap-2 ${className}`} {...props}>{children}</Comp>;
}

export function GhostButton({ as = "button", className = "", children, ...props }) {
    const Comp = as;
    return <Comp className={`btn-ghost-cream rounded-full px-6 py-3 text-sm inline-flex items-center justify-center gap-2 ${className}`} {...props}>{children}</Comp>;
}
